var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from '@colyseus/schema';
export const VOTE_ANOTHER_ROUND = '__another_round__';
export class Vote extends Schema {
    constructor() {
        super(...arguments);
        this.voterId = '';
        this.targetId = '';
        this.lastChangeAt = 0;
    }
}
__decorate([
    type('string')
], Vote.prototype, "voterId", void 0);
__decorate([
    type('string')
], Vote.prototype, "targetId", void 0);
__decorate([
    type('number')
], Vote.prototype, "lastChangeAt", void 0);
//# sourceMappingURL=Vote.js.map